import SearchDropdown, { type Option } from '@allesauto/core/searchDropdown';
import { SchemaTypes } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import { DropdownOpenHeight } from '@allesauto/utils/consts';
import React, { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';

import { MerchantLocationFilterStateProps } from '@/store/redux/actions/pages/pcp/filters/merchantLocation';

export interface MerchantLocationFilterProps {
  className?: string;
  merchantLocations: {
    merchantLocation: SchemaTypes.MerchantFacet[];
  };
  onMerchantLocationFilterChange: (
    merchantLocation: MerchantLocationFilterStateProps
  ) => void;
  selected: MerchantLocationFilterStateProps;
}

const transformListToSearchDropdown = (
  values: SchemaTypes.MerchantFacet[]
): Option[] => {
  const searchDropdownList =
    values &&
    (values.map((value) =>
      value?.name && value.displayName
        ? {
            value: value.name,
            label: value.displayName,
          }
        : null
    ) as Option[]);
  return searchDropdownList || [];
};

const MerchantLocationFilter: FC<
  React.PropsWithChildren<MerchantLocationFilterProps>
> = ({ merchantLocations, onMerchantLocationFilterChange, selected }) => {
  const intl = useIntl();
  const trackingIdentifierMerchantLocation = 'aa-filter--merchantLocation';

  const className = {
    subTitleDropdown: 'text-white pb-10px',
    elementContentDropdown: 'mb-20px',
  };

  const { merchantLocation } = merchantLocations;
  const headlinePosition = 'top';

  const merchantLocationForSearchDropdown: Option[] =
    transformListToSearchDropdown(merchantLocation);

  const merchantLocationDropdownChange = useCallback(
    (options: Option | readonly Option[] | null) => {
      let merchantLocation = [...(selected.merchantLocation || [])];

      if (Array.isArray(options)) {
        merchantLocation = options;
      }
      onMerchantLocationFilterChange({ ...selected, merchantLocation });
    },
    [selected, onMerchantLocationFilterChange]
  );

  return (
    <>
      <div className={className.subTitleDropdown}>
        {translate(intl, 'ui.PCP.FILTERS.MERCHANT_LOCATION.LOCATION_HEADLINE')}
      </div>
      <div className={className.elementContentDropdown}>
        <SearchDropdown
          id={trackingIdentifierMerchantLocation}
          placeholder={translate(
            intl,
            'ui.PCP.FILTERS.MERCHANT_LOCATION.FILTER_PLACEHOLDER'
          )}
          options={merchantLocationForSearchDropdown}
          darkBg={true}
          isMulti={true}
          hasInfoIcon={false}
          headlinePosition={headlinePosition}
          value={selected.merchantLocation || null}
          onChange={(value: Option | readonly Option[] | null) =>
            merchantLocationDropdownChange(value)
          }
          context="relative-position"
          openHeight={DropdownOpenHeight.MEDIUM}
        ></SearchDropdown>
      </div>
    </>
  );
};

export default MerchantLocationFilter;
